import '../lib/micromodal.js';

export default function setModal() {

  MicroModal.init({
    disableScroll: true
  });

}